
import store from '@/stores';
import {setAIHightLightInfo, setPanelDataByIndex} from '@/stores/slice/reading';
import {setIsSubject} from '@/stores/slice/listening';
import global from './global';

let applier: any;

function getAllAsteriskIndices(a: string): number[] {
  const indices: number[] = [];

  for (let i = 0; i < a.length; i++) {
    if (a[i] === '*') {
      indices.push(i);
    }
  }

  return indices;
}

function findMatchPositionAndLength(a: string, b: string): { position: number; totalLength: number; } {
  // 检查是否存在星号分隔
  const hasAsterisk = a.includes('*');
  let position = -1;
  let totalLength = 0;

  if (a.includes(b) || !hasAsterisk) {
    return {
      position: a.indexOf(b),
      totalLength: b.length,
    };
  }

  const newStr = a.replaceAll('*', '');
  const newMatch = b.replaceAll('*', '');

  if (!newStr.includes(newMatch)) {
    return { position: -1, totalLength: 0 };
  }

  const Tposition = getAllAsteriskIndices(a);
  position = newStr.indexOf(newMatch);
  totalLength = b.length;


  position += Tposition.filter((e) => { return e <= position; }).length;
  // 返回匹配的位置和总长度
  return { position, totalLength };
}

export function toReference(ans: any) {
  if (!applier) {
    applier= (window as any).rangy.createClassApplier('highLight', {
      tagName: ['span']
    });
  }
  const { location, key, content } = ans;

  const limits = store.getState().reading.limits;

  const pageDataIndex = store.getState().reading.pageDataIndex;
  if (global.subject === 'listen') {
    const isSubject = store.getState().listening.isSubject;
    if (!isSubject) {
      store.dispatch(setIsSubject(true));
    }
  }
  

  const number:number = parseFloat(key.split('_')[0]);

  const fIndex = limits.findIndex(item => {
    return number >= item.min && number <= item.max;
  });

  if (fIndex === -1) {
    return;
  }

  if (fIndex !== pageDataIndex) {
    store.dispatch(setPanelDataByIndex({index: fIndex}));
  }

  const el = document.getElementById(`article${fIndex}`);
  console.log('Paragraph', el);
  const goToHandle = () => {
    const el = document.getElementById(`article${fIndex}`);

    const rangeArr: any[] = [];

    const isScrolled = false;
    
    const posArr = location.map((itemLocation: any) => {
  
      const {target_para, index, length} = itemLocation;
      // 创建一个 Rangy Range 对象
      const range = (window as any).rangy.createRange();
  
      const regNum = /^[0-9]+$/;
  
  
      let key; 
      if (regNum.test(target_para)) {
        key = `question.content.paragraph.${target_para}`;
      } else {
        key = `question.content.${target_para}`;
      }

      const node = el?.querySelector(`[data-key='${key}']`);

      if (!node) {
        return null;
      }

      console.log('Node', node);

      const paraText = (node as HTMLElement).innerText;
      const { position, totalLength } = findMatchPositionAndLength(paraText, content);

      console.log('Position', paraText, content);

      // const textNode = node?.firstChild;
  
      // 设置 Range 的起始点和结束点
      // range.setStart(textNode, index); // 在 "This is a sample text" 的 'sample' 开始
      // range.setEnd(textNode, index + length); //
  
      
      
      // rangeArr.push(range);
      
      node?.scrollIntoView({block: 'center', behavior: 'smooth'});
      // applier.applyToRange(range);
      if (node) {
        return {
          startOffset: position,
          endOffset: position + totalLength,
          dataKey: key,
          className: 'aiText',
          tagName: 'strong'
        };
      }
  
    });
  
    const posObj = posArr.reduce((memo:any, item: any) => {
      const {dataKey} = item;
      if (memo[dataKey]) {
        memo[dataKey].push(item);
      } else {
        memo[dataKey] = [item];
      }
      return memo;
    }, {});
  
   
  
  
    store.dispatch(setAIHightLightInfo({posObj, posArr}));
    store.dispatch(setPanelDataByIndex({index: fIndex, forceRender: true}));
    const selection = (window as any).rangy.getSelection();
  
    selection.removeAllRanges();
  
    rangeArr.forEach(range => {
      selection.addRange(range);
    });
  };
  if (!el) {
    setTimeout(() => {
      goToHandle();
    }, 20);
    return;
  } 
  goToHandle();
  
}
  